module.exports = __webpack_public_path__ + "media/images/ping/ping_amarillo-5b7241d05a8a05e9bbe014fa62a8703c.svg";